import React from 'react';
import { Link } from 'react-router-dom';

export default function Projects() {
  const projects = [
    {
      id: 'timed-trials',
      title: 'Timed Trials | Motivosity',
      description: 'Led the creation of a Timed Trials solution, revolutionizing how customers trial add-ons. This Angular2 project streamlined the user experience with a seamless sign-up process, dynamic displays, and integration with internal tools.',
      tech: ['Angular 2', 'TypeScript', 'SQL'],
      image: '/images/timed-trials/1.png',
    },
    {
      id: 'motivosity-website',
      title: 'Motivosity Website',
      description: 'Created a complete website transformation for Motivosity, dedicated to marketing and client interactions. Ground-up redesign solidified Motivosity\'s brand identity.',
      tech: ['React', 'Gatsby', 'GraphQL'],
      image: '/images/motivosity-website/1.png',
    },
    {
      id: 'health-score',
      title: 'Company Health Scores',
      description: 'As the backend engineer, integrated Java, AngularJS, and SQL to efficiently generate internal health scores providing valuable insights into customer status.',
      tech: ['Java', 'AngularJS', 'SQL'],
      image: '/images/health-score/2.png',
    },
    {
      id: 'advisor-app',
      title: 'Financial Advisor Mobile App',
      description: 'Angular & Ionic mobile app providing financial advisors with a powerful tool to efficiently manage client portfolios.',
      tech: ['Angular', 'Ionic', 'TypeScript'],
      image: '/images/advisor-app/1.png',
    },
    {
      id: 'encircle-app',
      title: 'Encircle React Native App',
      description: 'Mobile app development combining technology stacks to deliver a feature-rich application in support of Encircle\'s services for the LGBT+ community.',
      tech: ['React Native', 'JavaScript', 'Firebase'],
      image: '/images/encircle-app/2.png',
    },
    {
      id: 'abgc-website',
      title: 'CMS Corporate Website',
      description: 'Corporate website redesign built with a popular CMS to allow non-technical users easy resource creation.',
      tech: ['CMS', 'HTML', 'CSS'],
      image: '/images/abgc-website/1.png',
    },
  ];

  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold mb-4 text-gray-900">Featured Projects</h2>
        <p className="text-lg text-gray-600 mb-12">Explore my professional work across various technologies and domains</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project) => (
            <Link key={project.id} to={`/project/${project.id}`} className="group">
              <div className="bg-white rounded-lg shadow-lg hover:shadow-2xl transition overflow-hidden">
                <div className="relative overflow-hidden h-48 bg-gray-200">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition">{project.title}</h3>
                  <p className="text-gray-600 mb-4">{project.description}</p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.tech.map((tech, idx) => (
                      <span key={idx} className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                        {tech}
                      </span>
                    ))}
                  </div>
                  <span className="text-blue-600 font-semibold group-hover:text-blue-800">
                    Learn more →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
